import { DependencyList, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useBreadcrumb } from 'hooks'
import { Breadcrumb } from 'lib/_types'
import { ROUTE_PATH } from 'lib/paths'
import { useCurrentUser } from 'store/api/yay/user'

export const useSettingBreadcrumbs = (
  nestedBreadcrumbs: Breadcrumb[],
  ...dep: DependencyList
) => {
  const { t } = useTranslation()
  const { setBreadcrumb } = useBreadcrumb()
  const { data: currentUser } = useCurrentUser()

  useEffect(() => {
    setBreadcrumb([
      {
        title: t('common.user'),
        link: ROUTE_PATH.USER(currentUser?.id),
      },
      {
        title: t('common.setting'),
      },
      ...nestedBreadcrumbs,
    ])
  }, dep)
}
